<template>
  <div class="quill-on-lesson" ref="quillelement">
    <weip :textInput="text"
          @changed="changed"
          :isInTestOfSaveButton="false"
          :noteType="noteType">
    </weip>
    <textarea :name="'event[' + noteType + ']'"
              :id="'event_' + noteType"
              class="none"
              type="hidden"
              v-model="serverText">
    </textarea>
  </div>
</template>

<script>
  import weip from '../common/AppEIPWYZIWYG'

  export default {
    props: {
      text: {
        type: String
      },
      noteType: {
        type: String,
        default: ''
      }
    },
    components: {
      weip
    },
    data () {
      return {
        serverText: ''
      }
    },
    methods: {
      changed (text) {
        this.serverText = text
        const el = this.$refs.quillelement.closest('.djs-slidein-form')
        if (el) {
          el.setAttribute('data-form-changes', 'true')
        }
      }
    },
    beforeMount () {
      this.serverText = this.text
    }
  }
</script>



// WEBPACK FOOTER //
// QuillOnLesson.vue?3c59821f